import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { MenuScrollLayout, MenuScrollLayoutProps } from "../MenuScrollLayout";

export type MenuComponentProps = {
    /** Obsah sekce */
    children: ReactNode;
    /** Příznak, zda se má použít barva pozadí pro submenu. */
    hasSubmenuBackground?: boolean;
    /**
     * Nastaví komponentu do jednoduchého zobrazení. V tomto módu komponenta neposkytuje hlavičku a scrollbar.
     * Typicky se používá v kombinaci s virtualizovaný listem.
     */
    isPlain?: boolean;
    /**
     * Obsah hlavičky. Je využit jen v případě, že není použitý mód jednoduchého zobrazení.
     * Hlavička je vykreslená vícekrát, kvůli sticky funkcionalitě, proto nemůže obsahovat unikátní prvky.
     * Více detailů v komponentě MenuScrollLayout.
     */
    headerContent?: MenuScrollLayoutProps["stickyHeaderContent"];
    /** Nastavení zarovnání obsahu. */
    contentPosition?: MenuComponentContentPosition;
};

const classNames = bemClassNames("menu-component");

/** Obecná komponenta reprezentující sekci menu. */
export const MenuComponent: FunctionComponent<MenuComponentProps> = ({
    children,
    headerContent,
    hasSubmenuBackground = false,
    isPlain = false,
    contentPosition = MenuComponentContentPosition.top,
}) => (
    <div className={classNames({
        "submenu-background": hasSubmenuBackground,
        "bottom": contentPosition === MenuComponentContentPosition.bottom,
        "center": contentPosition === MenuComponentContentPosition.center,
    })}>
        {isPlain ? (
            children
        ) : (
            <MenuScrollLayout horizontal={false} stickyHeaderContent={headerContent} usePaddedScrollbars={true}>
                {children}
            </MenuScrollLayout>
        )}
    </div>
);

export enum MenuComponentContentPosition {
    /** Defaultní zobrazení. */
    top = "top",
    /** Zarovnání ke spodnímu okraji. */
    bottom = "bottom",
    /** Vertikální zarovnání na střed. */
    center = "center",
}
